<template>
  <div class="reportManage">
    <div class="listWarpper">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <!-- <div class="opt">
            <el-select
              v-model="status"
              placeholder="请选择"
              @change="optChange"
            >
              <el-option
                v-for="item in options"
                :key="item.status"
                :label="item.label"
                :value="item.status"
              ></el-option>
            </el-select>
          </div> -->
          <div class="opt">
            <el-date-picker is-range v-model="searchTime" type="datetimerange" align="center" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" @change="timeChange">
            </el-date-picker>
          </div>
          <el-button type="text" style="margin-left:50px" @click="empty">清空条件</el-button>
        </div>
        <div class="bd content_card">
          <div v-if="listData.length != 0">
            <el-table align="center" :data="listData" height="500px" border style="width:99.9%;">
              <el-table-column align="center" prop="reportNumber" label="编号">
              </el-table-column>
              <el-table-column prop="memberName" align="center" label="会员名称">
              </el-table-column>
              <el-table-column prop="prescriptionInfoText.caseInfo.name" align="center" label="患者姓名">
              </el-table-column>
              <el-table-column prop="createTime" align="center" label="创建日期">
              </el-table-column>
              <el-table-column prop="" align="center" label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="reportDetail(scope.$index, scope.row)">预览</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="page">
              <el-pagination @current-change="currentPageChange" :page-size="pageList.size" :current-page="pageList.current"
                layout="total, prev, pager, next" :total="pageList.total"></el-pagination>
            </div>
          </div>
          <div v-else class="empty">
            <emptyData />
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
const defalutAvatar = require("@/assets/images/default-avatar-doctor.png");
import { reportList } from "@/api";
import pdf from "vue-pdf";
import util from "@/utils";
import emptyData from "@/components/common/emptyData.vue";

export default {
  name: "",
  components: { pdf, emptyData },
  props: {},
  data() {
    return {
      pageSize: 5,
      pageNo: 1,
      user: {},
      searchTime: [],
      listData: [],
      pageList: {},
      defalutAvatar: defalutAvatar,
      statusList: ["待确认", "已确认", "已拒绝"],
      tabName: "",
      report_type: "", //报告类型
      options: [
        {
          status: "",
          label: "全部",
        },
        {
          status: "1",
          label: "眼球阅片报告",
        },
        {
          status: "2",
          label: "处方报告",
        },
      ],
      status: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      value2: "",
      screenWidth: 0
    };
  },
  watch: {
    screenWidth(val) {
      this.screenWidth = val
      if (this.screenWidth < 1919) {
        this.show = false
      } else {
        this.show = true
      }
    }
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = window.innerWidth
        that.screenWidth = window.screenWidth;
      })()
    }
    this.getReportList();
  },
  methods: {
    empty() {
      this.status = "";
      this.pageNo = 1
      this.searchTime = [];
      this.getReportList();
    },
    //时间搜索
    timeChange() {
      this.getReportList();
    },
    /**
     * 选择状态
     */
    optChange() {
      this.getReportList();
    },
    currentPageChange(val) {
      var that = this;
      that.pageNo = val;
      that.getReportList();
    },
    reportDetail(index, row) {
      window.open(
        row.pdfUrl_dictText,
        "_blank",
        "location=yes,height=960,width=960,scrollbars=yes,status=yes"
      );
    },
    async getReportList() {
      try {
        const that = this;
        let data = {
          // reportType: that.status,
          startTime: that.searchTime[0],
          endTime: that.searchTime[1],
          pageNo: that.pageNo,
          pageSize: that.pageSize,
        };
        let res = await reportList(data);
        if (res.success) {
          this.listData = res.result.records;
          this.pageList = res.result;
        }
      } catch (error) {
      }
    },
    handleClose(done) {
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.listWarpper {
  width: 98%;
}
.box-card {
  width: 98%;
}
.nodata {
  width: 250px !important;
  position: relative;
  // bottom: 100px;
}

.content {
  display: flex;
  padding: 20px;
  .c_img {
    flex: 0 0 10%;
    text-align: center;
    img {
      width: 100px;
    }
  }
  .text {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .centerBox {
    flex: 0 0 65%;
    margin-left: 15px;
  }
  .right_box {
    flex: 0 0 25%;
    text-align: center;
    .c_btn {
      color: #409eff;
      cursor: pointer;
    }
    .c_time {
      color: rgb(167, 157, 157);
    }
  }
}
.pdf span {
  display: block !important;
}
.reportManage {
  width: 100%;
  margin: 20px;
}
.reportManage .empty {
  width: 10%;
  height: 300px;
  margin: 0 auto;
  margin-top: 15%;
}
.opt {
  float: left;
  padding: 0 0 25px 0;
}
.opt:nth-child(2) {
  margin-left: 20px;
}
.page {
  text-align: center;
}
</style>
